// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","left":"Header_left__lY6if","right":"Header_right__Yp87q"};